// #ux-redesign-start: AppointmentsView rediseñada (Paso 7 — Patients)
// Reemplaza Card>CardBody por PageContainer + layout responsive.
// Layout: en mobile (default) apilado vertical; en lg+ 1/3 + 2/3.
// ─────────────────────────────────────────────────────────────────────────────

import React, { Fragment } from "react";
import { useTranslate } from "react-translate";
import { useSelector } from "react-redux";

import { PageContainer } from "components/ds";
import AppointmentsList from "components/Appointments/AppointmentsList";
import AppointmentsMyDoctors from "components/Appointments/AppointmentsMyDoctors";

const AppointmentsView = () => {
  const t = useTranslate("sidebar");
  const { mobile } = useSelector((state) => state.commonReducer);

  return (
    <Fragment>
      <PageContainer title={t("appointments") || "Mis Turnos"} icon="appointments">
        <div
          style={{
            display: "grid",
            gap: "var(--space-4)",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0, 1fr) minmax(0, 2fr)",
          }}
        >
          <AppointmentsList />
          <AppointmentsMyDoctors />
        </div>
      </PageContainer>
    </Fragment>
  );
};

export default AppointmentsView;
// #ux-redesign-end
